import styled from 'styled-components';
export const SkeletonWrapper = styled.div `
  animation-name: skeleton-loading;
  animation-duration: var(--transition-duration-5);
  animation-iteration-count: infinite;
  animation-timing-function: var(--transition-timing-ease);
  width: ${(props) => props.width};
  height: ${(props) => props.height};

  @keyframes skeleton-loading {
    0% {
      background: linear-gradient(90deg, #ffffff 0%, #ffffff 50.52%, #e3e3e3 100%);
    }
    25% {
      background: linear-gradient(90deg, #ffffff 0%, #e3e3e3 68.23%, #ffffff 100%);
    }
    50% {
      background: linear-gradient(90deg, #ffffff 0%, #e3e3e3 52.6%, #ffffff 100%);
    }
    75% {
      background: linear-gradient(90deg, #ffffff 5.21%, #e3e3e3 28.65%, #ffffff 100%);
    }
    100% {
      background: linear-gradient(90deg, #e3e3e3 0%, #ffffff 22.92%, #ffffff 100%);
    }
  }
`;
